"use client";

import { useBreakpointValue } from "@chakra-ui/react";
import React, { createContext, useContext } from "react";

export type MoveOnSizesToken =
  | "3xs"
  | "2xs"
  | "xs"
  | "sm"
  | "md"
  | "lg"
  | "xl"
  | "2xl"
  | "3xl"
  | "4xl"
  | "5xl"
  | "6xl"
  | "7xl"
  | "8xl"
  | "full";

interface SystemDesignContextType {
  isMobileDevice: boolean;
  minHeight: MoveOnSizesToken;
  drawerSize: {
    base: "full" | "sm" | "md" | "lg" | "xl";
    md: "full" | "sm" | "md" | "lg" | "xl";
  };
}

const SystemDesignContext = createContext<SystemDesignContextType | undefined>(
  undefined,
);

export function SystemDesignProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const isMobile = useBreakpointValue({ base: true, md: false }) ?? true;
  const isMobileDevice = React.useMemo(() => isMobile, [isMobile]);

  const minHeight = isMobileDevice ? "2xs" : "md";
  const drawerSize = { base: "full", md: "xl" } as const;

  return (
    <SystemDesignContext.Provider
      value={{
        isMobileDevice,
        minHeight,
        drawerSize,
      }}
    >
      {children}
    </SystemDesignContext.Provider>
  );
}

export function useSystemDesign() {
  const context = useContext(SystemDesignContext);
  if (context === undefined) {
    throw new Error(
      "useSystemDesign must be used within a SystemDesignProvider",
    );
  }
  return context;
}
